"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Rail = function Rail() {
  return /*#__PURE__*/_react.default.createElement(StyledRail, null);
};

var StyledRail = _styledComponents.default.div.withConfig({
  displayName: "StyledRail"
})(["position:absolute;height:36px;right:-56px;left:0;border-radius:8px;background-color:#f0f1f3;"]);

var _default = Rail;
exports.default = _default;